import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '../types';
import { AxiosError } from 'axios';
import { RequestStatusEnum } from '@shared/types';

interface UsersState {
    allUsersAreInState: boolean;
    users: User[];
    students: User[];
    usersIdsDownloading: number[];
    getAllUsersStatus: RequestStatusEnum;
    getAllUsersError: PayloadAction<AxiosError> | null;
    getStudentsStatus: RequestStatusEnum;
    getStudentsError: AxiosError | null;
}

const initialState: UsersState = {
    allUsersAreInState: false,
    users: [],
    students: [],
    usersIdsDownloading: [],
    getAllUsersStatus: RequestStatusEnum.NotRequested,
    getAllUsersError: null,
    getStudentsStatus: RequestStatusEnum.NotRequested,
    getStudentsError: null,
};

const usersSlice = createSlice({
    name: '@users',
    initialState,
    reducers: {
        putUserToState(state, action) {
            const newUser = action.payload;
            if (!state.users.find((user) => user.pk === newUser.pk)) {
                state.users = state.users.concat([newUser]);
            }
        },
        getUserRequest(state, action: PayloadAction<User['pk']>) {},
        setUserDownloading(state, action: PayloadAction<User['pk'] | User['pk'][]>) {
            state.usersIdsDownloading = state.usersIdsDownloading.concat(action.payload);
        },
        removeUserDownloading(state, action: PayloadAction<User['pk']>) {
            state.usersIdsDownloading = state.usersIdsDownloading.filter((userId) => userId !== action.payload);
        },
        getAllUsersRequest(state) {
            state.getAllUsersStatus = RequestStatusEnum.Loading;
        },
        getAllUsersSuccess(state, action: PayloadAction<User[]>) {
            state.getAllUsersStatus = RequestStatusEnum.Success;
            state.allUsersAreInState = true;
            state.users = action.payload;
        },
        getAllUsersError(state, action) {
            state.getAllUsersStatus = RequestStatusEnum.Error;
            state.getAllUsersError = action;
        },
        getStudentsRequest(state) {
            state.getStudentsStatus = RequestStatusEnum.Loading;
            state.getStudentsError = null;
        },
        getStudentsSuccess(state, action: PayloadAction<User[]>) {
            state.getStudentsStatus = RequestStatusEnum.Success;
            state.getStudentsError = null;
            state.students = action.payload;
        },
        getStudentsError(state, action) {
            state.getStudentsStatus = RequestStatusEnum.Error;
            state.getStudentsError = action.payload;
        },
    },
});

export default usersSlice.reducer;

export const {
    putUserToState,
    getUserRequest,
    setUserDownloading,
    removeUserDownloading,
    getAllUsersRequest,
    getAllUsersSuccess,
    getAllUsersError,
    getStudentsRequest,
    getStudentsSuccess,
    getStudentsError,
} = usersSlice.actions;
